import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Webcam } from '../models/webcam.model';
import { WebcamService } from '../services/webcam.service';
var EditWebcamComponent = /** @class */ (function () {
    function EditWebcamComponent(_matDialogRef, _snackBar, data, _webcamService) {
        this._matDialogRef = _matDialogRef;
        this._snackBar = _snackBar;
        this._webcamService = _webcamService;
        this.isNew = false;
        this.isLoading = true;
        this.webcam = data.webcam || new Webcam();
        this.isNew = data.isNew || false;
        this.businessID = data.busID;
        this.origWebcam = Object.assign(new Webcam(), data.webcam);
        this.itemsToChange = new Set();
        this.selectedName = this.webcam.name;
        this.selectedSite = this.webcam.site;
        this.selectedFacing = this.webcam.direction;
        this.selectedUrl = this.webcam.url;
    }
    EditWebcamComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            name: new FormControl(this.selectedName, [Validators.required, Validators.maxLength(100)]),
            url: new FormControl(this.selectedUrl, [Validators.required, Validators.maxLength(200),
                Validators.pattern('^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$')]),
            site: new FormControl(this.selectedName, [Validators.required, Validators.maxLength(100)]),
            facing: new FormControl(this.selectedFacing, [Validators.required, Validators.maxLength(30)])
        });
        this.isLoading = false;
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditWebcamComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        res = void 0;
                        this.webcam.url = this.formGroup.value.url;
                        this.webcam.name = this.formGroup.value.name;
                        this.webcam.site = this.formGroup.value.site;
                        this.webcam.direction = this.formGroup.value.facing;
                        if (!this.isNew) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._webcamService.postWebcam(this.businessID, this.webcam)];
                    case 1:
                        res = _a.sent();
                        this.webcam = Webcam.parse(res);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this._webcamService.putWebcam(this.businessID, this.webcam)];
                    case 3:
                        res = _a.sent();
                        Object.assign(this.webcam, Webcam.parse(res));
                        this.webcam = Webcam.parse(res);
                        _a.label = 4;
                    case 4:
                        this.close({ cancelBtnClicked: false, success: true, webcam: this.webcam });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    EditWebcamComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditWebcamComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            Object.assign(this.webcam, this.origWebcam);
        }
        data['isNew'] = this.isNew;
        this._matDialogRef.close(data);
    };
    return EditWebcamComponent;
}());
export { EditWebcamComponent };
